// apiUrl injected at build time (e.g. from GitHub Actions vars.STAGING_API_URL)
export const environment = {
    production: false,
    apiUrl: 'https://staging-api.safescan.tech/',
    version: 'v1.9',
    showMedicationId: true
};
